<footer class="footer">
    <div class="container-fluid">
        
        <p class="copyright ">
            &copy;Copyright {{test | date: 'yyyy'}} HenosisTech, Designed and Developed by<a href="http://www.henosistech.com" target="_blank">  Henosis Tech Pvt Ltd</a>
        </p>
    </div>
</footer>
